import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-4 mb-md-0" }
const _hoisted_2 = { class: "px-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "bg-gray-700" }
const _hoisted_6 = { class: "d-flex align-items-center fw-bolder p-3" }
const _hoisted_7 = { class: "badge badge-light-success ms-5 fs-md-2 ms-auto" }
const _hoisted_8 = { class: "badge badge-light-warning ms-5 fs-md-2" }
const _hoisted_9 = { class: "badge badge-light-danger ms-5 fs-md-2" }
const _hoisted_10 = { class: "card-header border-0 pt-6" }
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_14 = { class: "card-toolbar" }
const _hoisted_15 = {
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_16 = { class: "svg-icon svg-icon-2" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Add Production Stock ")
const _hoisted_18 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_19 = { class: "card-toolbar w-100" }
const _hoisted_20 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_21 = { class: "me-auto" }
const _hoisted_22 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1)
const _hoisted_24 = { class: "fw-bolder mx-5" }
const _hoisted_25 = { class: "me-2" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_27 = { class: "card-header border-0 pt-6" }
const _hoisted_28 = { class: "card-title" }
const _hoisted_29 = { class: "row w-100" }
const _hoisted_30 = { class: "col-md-12 d-flex align-items-center position-relative my-1" }
const _hoisted_31 = { class: "card-toolbar" }
const _hoisted_32 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_33 = {
  key: 0,
  class: "card-body pt-0 d-none d-md-block"
}
const _hoisted_34 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "d-md-none d-block" }
const _hoisted_45 = {
  key: 0,
  class: "card"
}
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" to add new Production Stock ")
const _hoisted_49 = { class: "card-header ribbon" }
const _hoisted_50 = { class: "card-title" }
const _hoisted_51 = { class: "ribbon-label bg-info" }
const _hoisted_52 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1)
const _hoisted_54 = { class: "flex-grow-1" }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = { class: "text-muted fw-bold d-block" }
const _hoisted_58 = { class: "text-muted fw-bold d-block" }
const _hoisted_59 = { class: "card-footer d-flex pt-1" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "back-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(`badge ${
              _ctx.stockCount.in - _ctx.stockCount.out > 0
                ? 'badge-success'
                : 'badge-danger'
            } ms-5 fs-md-2`)
          }, " Balance : " + _toDisplayString(_ctx.stockCount.in - _ctx.stockCount.out || 0), 3),
          _createElementVNode("div", _hoisted_7, " In : " + _toDisplayString(_ctx.stockCount.in || 0), 1),
          _createElementVNode("div", _hoisted_8, " Out : " + _toDisplayString(_ctx.stockCount.out || 0), 1),
          _createElementVNode("div", _hoisted_9, " Waste : " + _toDisplayString(_ctx.stockCount.waste || 0), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addProductionStock({})))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
              ]),
              _hoisted_17
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllProductionStock) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllProductionStock]
                ]),
                _hoisted_23
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectAllProductionStock ? _ctx.total : _ctx.checkedProductionStock.length), 1),
              _hoisted_26
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.name) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Search By Name"
              }, null, 512), [
                [_vModelText, _ctx.searchData.name]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems()))
            }, " Search ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.selectAllProductionStock)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_35))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedProductionStock) = $event))
                      }, null, 8, _hoisted_36)), [
                        [_vModelCheckbox, _ctx.checkedProductionStock]
                      ])
                ])
              ]),
              "cell-qty": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.qty), 1)
              ]),
              "cell-remark": _withCtx(({ row: site }) => [
                _createElementVNode("p", null, _toDisplayString(site.remark), 1)
              ]),
              "cell-stock_type": _withCtx(({ row: site }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`badge badge-${
                site.stock_type == 'In'
                  ? 'success'
                  : site.stock_type == 'Out'
                  ? 'warning'
                  : 'danger'
              }`)
                }, _toDisplayString(site.stock_type), 3)
              ]),
              "cell-production_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.production_data.code), 1)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-sm mx-2",
                    onClick: ($event: any) => (_ctx.addProductionStock(site))
                  }, _hoisted_40, 8, _hoisted_38),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger btn-sm mx-2",
                    onClick: ($event: any) => (_ctx.deleteProductionStockItem(site))
                  }, _hoisted_43, 8, _hoisted_41)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addProductionStock({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_48
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("h3", _hoisted_50, _toDisplayString(item.stock_type), 1),
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, " Remark: " + _toDisplayString(item.remark), 1),
                    _createElementVNode("div", _hoisted_58, " Quantity : ₹ " + _toDisplayString(item.qty), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                onClick: ($event: any) => (_ctx.addProductionStock(item.id))
              }, _hoisted_62, 8, _hoisted_60),
              false
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-danger mx-2 w-100",
                    onClick: ($event: any) => (_ctx.deleteProductionStockItem(item))
                  }, _hoisted_65, 8, _hoisted_63))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}